import { useToast } from '@chakra-ui/react';
import { useUnblockUserMutation } from '../../../../graphql/generated';
import { UserUnblockButtonProps } from './user-unblock-button';

export const useUnblockUser = () => {
  const toast = useToast();
  const [unblockUserMutation, { loading }] = useUnblockUserMutation();

  const unblockUser = async ({
    userId,
    userName,
    startTimedPolling,
  }: UserUnblockButtonProps) => {
    try {
      const { data } = await unblockUserMutation({
        variables: { userId },
      });

      if (data) {
        // Need to poll because Auth0 takes a few seconds to update
        startTimedPolling();

        toast({
          title: `Unblocked ${userName}`,
          status: 'success',
          position: 'top',
        });
      }
    } catch {
      toast({
        title: `Unable to unblock ${userName}`,
        description: `Please try again`,
        status: `error`,
        position: `top`,
      });
    }
  };

  return {
    unblockUser,
    isUnblockLoading: loading,
  };
};
